module.exports = __webpack_public_path__ + "img/RYO_S.7ae51793.png";